/* eslint-disable no-underscore-dangle */
import ObjectivePossibleAdverseChangesToFinancialSituation from '__core/shared/model/finance/ObjectivePossibleAdverseChangesToFinancialSituation';
import ObjectivePossibleBeneficialChangesToFinancialSituation from '__core/shared/model/finance/ObjectivePossibleBeneficialChangesToFinancialSituation';
import template from './needsAndObjectives.template.html';

export default {
  template,
  bindings: {
    formName: '<',
    objectives: '<',
    workflow: '<',
    diversificationOpportunities: '<',
    contacts: '<',
    addresses: '<',
    documents: '<',
    outboundReferrers: '<',
    validationErrors: '<',
    loan: '<',
    ticketOwner: '<',
    ticket: '<',
    compliance: '<',
    idAli: '<',
    isAssetFinanceCommercial: '<',
    showBidFlows: '<',
    isTicketSettled: '<',
    onFinished: '&',
    onDiversificationFinished: '&',
    onDiversificationIntegrationFinished: '&'
  },
  controller: class controller {
    constructor(
      $rootScope,
      $timeout,
      $mdUtil,
      helperService,
      needsAndObjectivesService,
      OpportunityContextualType,
      diversificationOpportunityService,
      assetFinanceService,
      dateTimeService,
      YesNoOption,
      ObjectiveApplicant
    ) {
      'ngInject';

      const ctrl = this;
      ctrl.currentOrganization = $rootScope.CurrentOrganization;
      ctrl.currentCurrency = $rootScope.CurrentCurrency();
      ctrl.currentDateFormat = $rootScope.CurrentDateFormatPrimary();
      ctrl.organizationCountry = '';
      ctrl.availableLevelOptions = [];
      ctrl.availableYesNoOptionOne = [];
      ctrl.availableYesNoOptionThree = [];
      ctrl.availableObjectivePaymentPreferenceOptions = [];
      ctrl.availablePaymentFrequencies = [];
      ctrl.availableCreditRecords = [];
      ctrl.availableObjectivePayBallonOptions = [];
      ctrl.availableTermInMonths = [];
      ctrl.isReady = false;

      ctrl.initialize = () => {
        ctrl.organizationCountry = helperService.getOrganizationCountry();
        ctrl.availableLevelOptions = helperService.getAvailableLevelOptions();
        ctrl.availableYesNoOptionOne = helperService.getAvailableYesNoOptions({ option: 1 });
        ctrl.objectives = ctrl.objectives || {};
        ctrl.workflow = ctrl.workflow || {};
        ctrl.diversificationOpportunities = ctrl.diversificationOpportunities || [];
        ctrl.contacts = ctrl.contacts || [];
        ctrl.addresses = ctrl.addresses || [];
        ctrl.documents = ctrl.documents || [];
        ctrl.outboundReferrers = ctrl.outboundReferrers || [];
        ctrl.validationErrors = ctrl.validationErrors || [];
        ctrl.loan = ctrl.loan || {};
        ctrl.ticketOwner = ctrl.ticketOwner || {};
        ctrl.ticket = ctrl.ticket || {};
        ctrl.compliance = ctrl.compliance || {};
        ctrl.idAli = ctrl.idAli || '';
        ctrl.personContacts = _.filter(ctrl.contacts, (c) => !c.isCompany);
        ctrl.isAssetFinanceCommercial = ctrl.isAssetFinanceCommercial || false;
        ctrl.showBidFlows = ctrl.showBidFlows || false;
        ctrl.isTicketSettled = ctrl.isTicketSettled || false;
        if (ctrl.workflow && ctrl.workflow.isAssetFinance()) {
          ctrl.availableObjectivePaymentPreferenceOptions =
            helperService.getAvailableObjectivePaymentPreferenceOptions();
          ctrl.availablePaymentFrequencies = helperService.getAvailablePaymentFrequencies({
            workflow: ctrl.workflow,
            loanPurpose: ctrl.isAssetFinanceCommercial ? 'commercial' : 'consumer'
          });
          ctrl.availableCreditRecordOptions = helperService.getAvailableCreditRecordOptions();
          ctrl.availableYesNoOptionThree = helperService.getAvailableYesNoOptions({
            option: 3
          });
          ctrl.availableObjectivePayBallonOptions =
            helperService.getAvailableObjectivePayBallonOptions();
          ctrl.availableTermInMonths = helperService.getAvailableTermInMonths({
            isRegular: true
          });
        }
        ctrl.setNeedsAndObjectivesErrors();
        ctrl.setApplicants();
        ctrl.setTotalAmountOfCreditSought();
        dateTimeService.getSet(
          ctrl,
          ctrl.objectives?.possibleAdverseChangesToFinancialSituation?.natureOfPlannedChange,
          'extendedUnpaidLeaveFromDate',
          'getSetExtendedUnpaidLeaveFromDate'
        );
        dateTimeService.getSet(
          ctrl,
          ctrl.objectives?.possibleAdverseChangesToFinancialSituation?.natureOfPlannedChange,
          'extendedUnpaidLeaveToDate',
          'getSetExtendedUnpaidLeaveToDate'
        );
        dateTimeService.getSet(
          ctrl,
          ctrl.objectives?.possibleAdverseChangesToFinancialSituation?.natureOfPlannedChange,
          'reducedIncomeFromDate',
          'getSetReducedIncomeFromDate'
        );
        dateTimeService.getSet(
          ctrl,
          ctrl.objectives?.possibleAdverseChangesToFinancialSituation?.natureOfPlannedChange,
          'reducedIncomeToDate',
          'getSetReducedIncomeToDate'
        );
        dateTimeService.getSet(
          ctrl,
          ctrl.objectives?.possibleAdverseChangesToFinancialSituation?.natureOfPlannedChange,
          'endOfContractFromDate',
          'getSetEndOfContractFromDate'
        );
        dateTimeService.getSet(
          ctrl,
          ctrl.objectives?.possibleAdverseChangesToFinancialSituation?.natureOfPlannedChange,
          'endOfContractToDate',
          'getSetEndOfContractToDate'
        );
        dateTimeService.getSet(
          ctrl,
          ctrl.objectives?.possibleAdverseChangesToFinancialSituation?.natureOfPlannedChange,
          'leavingEmploymentFromDate',
          'getSetLeavingEmploymentFromDate'
        );
        dateTimeService.getSet(
          ctrl,
          ctrl.objectives?.possibleAdverseChangesToFinancialSituation?.natureOfPlannedChange,
          'leavingEmploymentToDate',
          'getSetLeavingEmploymentToDate'
        );
        dateTimeService.getSet(
          ctrl,
          ctrl.objectives?.possibleAdverseChangesToFinancialSituation?.natureOfPlannedChange,
          'increasedDebtRepaymentsFromDate',
          'getSetIncreasedDebtRepaymentsFromDate'
        );
        dateTimeService.getSet(
          ctrl,
          ctrl.objectives?.possibleAdverseChangesToFinancialSituation?.natureOfPlannedChange,
          'increasedDebtRepaymentsToDate',
          'getSetIncreasedDebtRepaymentsToDate'
        );
        dateTimeService.getSet(
          ctrl,
          ctrl.objectives?.possibleAdverseChangesToFinancialSituation?.natureOfPlannedChange,
          'largeExpenditureFromDate',
          'getSetLargeExpenditureFromDate'
        );
        dateTimeService.getSet(
          ctrl,
          ctrl.objectives?.possibleAdverseChangesToFinancialSituation?.natureOfPlannedChange,
          'largeExpenditureToDate',
          'getSetLargeExpenditureToDate'
        );
        dateTimeService.getSet(
          ctrl,
          ctrl.objectives?.possibleAdverseChangesToFinancialSituation?.natureOfPlannedChange,
          'medicalTreatmentFromDate',
          'getSetMedicalTreatmentFromDate'
        );
        dateTimeService.getSet(
          ctrl,
          ctrl.objectives?.possibleAdverseChangesToFinancialSituation?.natureOfPlannedChange,
          'medicalTreatmentToDate',
          'getSetMedicalTreatmentToDate'
        );
        dateTimeService.getSet(
          ctrl,
          ctrl.objectives?.possibleAdverseChangesToFinancialSituation?.natureOfPlannedChange,
          'otherFromDate',
          'getSetOtherFromDate'
        );
        dateTimeService.getSet(
          ctrl,
          ctrl.objectives?.possibleAdverseChangesToFinancialSituation?.natureOfPlannedChange,
          'otherToDate',
          'getSetOtherToDate'
        );
        $timeout(() => {
          ctrl.setDiversificationOpportunities();
          ctrl.isReady = true;
        });
      };

      ctrl.setNeedsAndObjectivesErrors = () => {
        ctrl.needsAndObjectivesErrors = _.filter(
          ctrl.validationErrors,
          (v) => v?.message?.toLowerCase()?.indexOf('needs and objectives -') > -1
        );
      };

      ctrl.setApplicants = () => {
        ctrl.objectives = needsAndObjectivesService.setApplicants(
          ctrl.objectives,
          ctrl.personContacts
        );
        ctrl.saveNeedsAndObjectives();
      };

      ctrl.setTotalAmountOfCreditSought = () => {
        ctrl.objectives.requirementsAndObjectives.purposeDetails.totalAmount = _.sum([
          helperService.isNumber(
            ctrl.objectives.requirementsAndObjectives.purposeDetails.purchasePropertyAmount,
            true
          ),
          helperService.isNumber(
            ctrl.objectives.requirementsAndObjectives.purposeDetails.constructionAmount,
            true
          ),
          helperService.isNumber(
            ctrl.objectives.requirementsAndObjectives.purposeDetails.renovationsAmount,
            true
          ),
          helperService.isNumber(
            ctrl.objectives.requirementsAndObjectives.purposeDetails.investmentPurposesAmount,
            true
          ),
          helperService.isNumber(
            ctrl.objectives.requirementsAndObjectives.purposeDetails.purchaseAssetAmount,
            true
          ),
          helperService.isNumber(
            ctrl.objectives.requirementsAndObjectives.purposeDetails.refinanceAmount,
            true
          ),
          helperService.isNumber(
            ctrl.objectives.requirementsAndObjectives.purposeDetails.debtConsolidationAmount,
            true
          ),
          helperService.isNumber(
            ctrl.objectives.requirementsAndObjectives.purposeDetails.otherAmount,
            true
          )
        ]);
        ctrl.saveNeedsAndObjectives();
      };

      ctrl.setDiversificationOpportunities = () => {
        ctrl.objectiveMitigateRisk = OpportunityContextualType.objective_mitigate_risk;
        if (
          (ctrl.objectives?.requirementsAndObjectives?.purposeType?.isOwnerOccupier ||
            ctrl.objectives?.requirementsAndObjectives?.purposeType?.isInvestment) &&
          ctrl.objectives?.requirementsAndObjectives?.purposeDetails?.purchaseProperty
        ) {
          ctrl.objectivePurchaseBuildingServices =
            OpportunityContextualType.objective_purchase_building_services;
        } else {
          const idxServices =
            diversificationOpportunityService.getIndexOfContextualTypeInDiversificationOpportunities(
              {
                diversificationOpportunities: ctrl.diversificationOpportunities,
                typeContextual: OpportunityContextualType.objective_purchase_building_services
              }
            );
          if (idxServices > -1) {
            ctrl.diversificationOpportunities.splice(idxServices, 1);
          }
        }

        if (
          (ctrl.objectives?.requirementsAndObjectives?.purposeType?.isOwnerOccupier ||
            ctrl.objectives?.requirementsAndObjectives?.purposeType?.isInvestment) &&
          (ctrl.objectives?.requirementsAndObjectives?.purposeDetails?.purchaseProperty ||
            ctrl.objectives?.requirementsAndObjectives?.purposeDetails?.construction)
        ) {
          ctrl.objectivePurchasePropertySolicitor =
            OpportunityContextualType.objective_purchase_property_solicitor;
          ctrl.objectivePurchasePropertyUtility =
            OpportunityContextualType.objective_purchase_property_utility;
          ctrl.objectivePurchasePropertyCarAdvocacy =
            OpportunityContextualType.objective_purchase_property_car_advocacy;
          ctrl.objectivePurchasePropertyCarFinance =
            OpportunityContextualType.objective_purchase_property_car_finance;
        } else {
          const idxSolicitor =
            diversificationOpportunityService.getIndexOfContextualTypeInDiversificationOpportunities(
              {
                diversificationOpportunities: ctrl.diversificationOpportunities,
                typeContextual: OpportunityContextualType.objective_purchase_property_solicitor
              }
            );
          if (idxSolicitor > -1) {
            ctrl.diversificationOpportunities.splice(idxSolicitor, 1);
          }
          const idxUtility =
            diversificationOpportunityService.getIndexOfContextualTypeInDiversificationOpportunities(
              {
                diversificationOpportunities: ctrl.diversificationOpportunities,
                typeContextual: OpportunityContextualType.objective_purchase_property_utility
              }
            );
          if (idxUtility > -1) {
            ctrl.diversificationOpportunities.splice(idxUtility, 1);
          }
          const idxAdvocacy =
            diversificationOpportunityService.getIndexOfContextualTypeInDiversificationOpportunities(
              {
                diversificationOpportunities: ctrl.diversificationOpportunities,
                typeContextual:
                  OpportunityContextualType.objective_purchase_property_car_advocacy
              }
            );
          if (idxAdvocacy > -1) {
            ctrl.diversificationOpportunities.splice(idxAdvocacy, 1);
          }
          const idxFinance =
            diversificationOpportunityService.getIndexOfContextualTypeInDiversificationOpportunities(
              {
                diversificationOpportunities: ctrl.diversificationOpportunities,
                typeContextual:
                  OpportunityContextualType.objective_purchase_property_car_finance
              }
            );
          if (idxFinance > -1) {
            ctrl.diversificationOpportunities.splice(idxFinance, 1);
          }
        }

        if (
          (ctrl.objectives?.requirementsAndObjectives?.purposeType?.isOwnerOccupier ||
            ctrl.objectives?.requirementsAndObjectives?.purposeType?.isInvestment) &&
          (ctrl.objectives?.requirementsAndObjectives?.purposeDetails?.purchaseProperty ||
            ctrl.objectives?.requirementsAndObjectives?.purposeDetails?.construction ||
            ctrl.objectives?.requirementsAndObjectives?.purposeDetails?.debtConsolidation)
        ) {
          ctrl.objectivePurchaseDepositGuarantee =
            OpportunityContextualType.objective_purchase_deposit_guarantee;
        } else {
          const idxGuarantee =
            diversificationOpportunityService.getIndexOfContextualTypeInDiversificationOpportunities(
              {
                diversificationOpportunities: ctrl.diversificationOpportunities,
                typeContextual: OpportunityContextualType.objective_purchase_deposit_guarantee
              }
            );
          if (idxGuarantee > -1) {
            ctrl.diversificationOpportunities.splice(idxGuarantee, 1);
          }
        }

        if (
          ctrl.objectives?.requirementsAndObjectives?.purposeType?.isOwnerOccupier &&
          (ctrl.objectives?.requirementsAndObjectives?.purposeDetails?.purchaseProperty ||
            ctrl.objectives?.requirementsAndObjectives?.purposeDetails?.construction)
        ) {
          ctrl.objectivePurchasePropertyCertificate =
            OpportunityContextualType.objective_purchase_property_certificate;
        } else {
          const idxCertificate =
            diversificationOpportunityService.getIndexOfContextualTypeInDiversificationOpportunities(
              {
                diversificationOpportunities: ctrl.diversificationOpportunities,
                typeContextual:
                  OpportunityContextualType.objective_purchase_property_certificate
              }
            );
          if (idxCertificate > -1) {
            ctrl.diversificationOpportunities.splice(idxCertificate, 1);
          }
        }

        if (
          ctrl.objectives?.requirementsAndObjectives?.purposeType?.isInvestment &&
          (ctrl.objectives?.requirementsAndObjectives?.purposeDetails?.purchaseProperty ||
            ctrl.objectives?.requirementsAndObjectives?.purposeDetails?.construction)
        ) {
          ctrl.objectivePurchasePropertyRental =
            OpportunityContextualType.objective_purchase_property_rental;
          ctrl.objectivePurchasePropertyProtection =
            OpportunityContextualType.objective_purchase_property_protection;
        } else {
          const idxInvestment =
            diversificationOpportunityService.getIndexOfContextualTypeInDiversificationOpportunities(
              {
                diversificationOpportunities: ctrl.diversificationOpportunities,
                typeContextual: OpportunityContextualType.objective_purchase_property_rental
              }
            );
          if (idxInvestment > -1) {
            ctrl.diversificationOpportunities.splice(idxInvestment, 1);
          }
          const idxLandlord =
            diversificationOpportunityService.getIndexOfContextualTypeInDiversificationOpportunities(
              {
                diversificationOpportunities: ctrl.diversificationOpportunities,
                typeContextual: OpportunityContextualType.objective_purchase_property_protection
              }
            );
          if (idxLandlord > -1) {
            ctrl.diversificationOpportunities.splice(idxLandlord, 1);
          }
        }

        if (
          ctrl.objectives?.financialSecurity?.haveWill?.name ===
          ctrl.availableYesNoOptionOne[1]?.name
        ) {
          ctrl.objectiveWill = OpportunityContextualType.objective_will;
        } else {
          const idxWill =
            diversificationOpportunityService.getIndexOfContextualTypeInDiversificationOpportunities(
              {
                diversificationOpportunities: ctrl.diversificationOpportunities,
                typeContextual: OpportunityContextualType.objective_will
              }
            );
          if (idxWill > -1) {
            ctrl.diversificationOpportunities.splice(idxWill, 1);
          }
        }

        if (
          ctrl.objectives?.creditHistory?.applicantHadProblems?.name ===
            ctrl.availableYesNoOptionOne[0]?.name ||
          ctrl.objectives?.creditHistory?.applicantBeenOfficerOrShareholder?.name ===
            ctrl.availableYesNoOptionOne[0]?.name ||
          ctrl.objectives?.creditHistory?.applicantHaveUnsatisfiedJudgements?.name ===
            ctrl.availableYesNoOptionOne[0]?.name
        ) {
          ctrl.objectiveCreditHistory = OpportunityContextualType.objective_credit_history;
        } else {
          const idxHistory =
            diversificationOpportunityService.getIndexOfContextualTypeInDiversificationOpportunities(
              {
                diversificationOpportunities: ctrl.diversificationOpportunities,
                typeContextual: OpportunityContextualType.objective_credit_history
              }
            );
          if (idxHistory > -1) {
            ctrl.diversificationOpportunities.splice(idxHistory, 1);
          }
        }
        ctrl.saveDiversificationOpportunities(ctrl.diversificationOpportunities);
      };

      ctrl.togglePossibleAdverseChangesToFinancialSituation = () => {
        if (
          ctrl.objectives?.possibleAdverseChangesToFinancialSituation
            ?.planChangesToTheirFinancialCircumstances?.name === YesNoOption.no.name
        ) {
          ctrl.objectives.possibleAdverseChangesToFinancialSituation.applicants = [];
          for (let c = 0; c < ctrl.personContacts?.length; c += 1) {
            ctrl.objectives.possibleAdverseChangesToFinancialSituation.applicants.push(
              ObjectiveApplicant.blank(ctrl.personContacts[c].id)
            );
          }
          ctrl.objectives.possibleAdverseChangesToFinancialSituation =
            new ObjectivePossibleBeneficialChangesToFinancialSituation({
              planChangesToTheirFinancialCircumstances:
                ctrl.objectives?.possibleAdverseChangesToFinancialSituation
                  ?.planChangesToTheirFinancialCircumstances || YesNoOption.none,
              applicants:
                ctrl.objectives.possibleAdverseChangesToFinancialSituation.applicants || []
            });
          ctrl.__getSetExtendedUnpaidLeaveFromDate = '';
          ctrl.__getSetExtendedUnpaidLeaveToDate = '';
          ctrl.__getSetReducedIncomeFromDate = '';
          ctrl.__getSetReducedIncomeToDate = '';
          ctrl.__getSetEndOfContractFromDate = '';
          ctrl.__getSetEndOfContractToDate = '';
          ctrl.__getSetLeavingEmploymentFromDate = '';
          ctrl.__getSetLeavingEmploymentToDate = '';
          ctrl.__getSetIncreasedDebtRepaymentsFromDate = '';
          ctrl.__getSetIncreasedDebtRepaymentsToDate = '';
          ctrl.__getSetLargeExpenditureFromDate = '';
          ctrl.__getSetLargeExpenditureToDate = '';
          ctrl.__getSetMedicalTreatmentFromDate = '';
          ctrl.__getSetMedicalTreatmentToDate = '';
          ctrl.__getSetOtherFromDate = '';
          ctrl.__getSetOtherToDate = '';
        }
        ctrl.saveNeedsAndObjectives();
      };

      ctrl.togglePossibleBeneficialChangesToFinancialSituation = () => {
        if (
          ctrl.objectives?.possibleBeneficialChangesToFinancialSituation
            ?.planChangesToTheirFinancialCircumstances?.name === YesNoOption.no.name
        ) {
          ctrl.objectives.possibleBeneficialChangesToFinancialSituation.applicants = [];
          for (let c = 0; c < ctrl.personContacts?.length; c += 1) {
            ctrl.objectives.possibleBeneficialChangesToFinancialSituation.applicants.push(
              ObjectiveApplicant.blank(ctrl.personContacts[c].id)
            );
          }
          ctrl.objectives.possibleBeneficialChangesToFinancialSituation =
            new ObjectivePossibleAdverseChangesToFinancialSituation({
              planChangesToTheirFinancialCircumstances:
                ctrl.objectives?.possibleBeneficialChangesToFinancialSituation
                  ?.planChangesToTheirFinancialCircumstances || YesNoOption.none,
              applicants:
                ctrl.objectives.possibleBeneficialChangesToFinancialSituation.applicants || []
            });
        }
        ctrl.saveNeedsAndObjectives();
      };

      ctrl.getContact = (idContact) => {
        let contact;
        if (ctrl.personContacts.length) {
          contact = ctrl.personContacts.find((c) => c.id === idContact);
        }
        return contact;
      };

      ctrl.hasValidationError = ({ path }) =>
        helperService.hasValidationError({ errors: ctrl.needsAndObjectivesErrors, path });

      ctrl.saveNeedsAndObjectivesBankruptcy = (bankruptcy) => {
        const idx = _.findIndex(
          ctrl.objectives?.creditHistory?.bankruptcy || [],
          (b) => b?.id === bankruptcy?.id
        );
        if (idx > -1) {
          ctrl.objectives.creditHistory.bankruptcy[idx] = bankruptcy;
          ctrl.saveNeedsAndObjectives();
        }
      };

      ctrl.saveNeedsAndObjectives = () => {
        ctrl.setDiversificationOpportunities();
        if (ctrl.isReady === true) {
          ctrl.onFinished({ objectives: ctrl.objectives });
        }
      };

      ctrl.saveDiversificationOpportunities = (diversificationOpportunities) => {
        if (ctrl.isReady === true) {
          ctrl.onDiversificationFinished({ diversificationOpportunities });
        }
      };

      ctrl.saveDiversificationIntegration = (integration, result) => {
        if (ctrl.isReady === true) {
          ctrl.onDiversificationIntegrationFinished({ integration, result });
        }
      };

      ctrl.$onInit = () => {
        ctrl.initialize();
      };

      ctrl.$onChanges = (changes) => {
        if (changes?.validationErrors?.currentValue) {
          ctrl.setNeedsAndObjectivesErrors();
        }
      };
    }
  }
};
